import type { HotelRoom } from '../types/HotelRoom';

export const roomsToQueryParams = (rooms?: HotelRoom[]): string[] =>
    rooms?.length ? rooms.map((room) => (room.children.length > 0 ? `${room.adults}-${room.children.join('.')}` : `${room.adults}`)) : [];
